import { render, staticRenderFns } from "./DocsEditor.vue?vue&type=template&id=68ce7341"
import script from "./DocsEditor.vue?vue&type=script&lang=js"
export * from "./DocsEditor.vue?vue&type=script&lang=js"
import style0 from "./DocsEditor.vue?vue&type=style&index=0&id=68ce7341&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports